import React, { useState, useEffect, useRef } from "react"

function useInterval(callback, delay) {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }

    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const Carousel = ({ carousel_media }) => {
  const filteredCarousel = carousel_media.filter(item => item.images !== null)
  const [index, setIndex] = useState(0)

  useInterval(() => {
    const nextIndex = index + 1
    setIndex(filteredCarousel.length <= nextIndex ? 0 : nextIndex)
  }, 3000)

  const image =
    filteredCarousel[index] &&
    filteredCarousel[index].images &&
    filteredCarousel[index].images.standard_resolution.url

  return (
    <div style={{ display: "flex" }}>
      {image && (
        <img src={image} style={{ transition: "opacity 1s ease-in-out" }} />
      )}
    </div>
  )
}

export default Carousel
